import { Component, OnInit } from '@angular/core';
import { CPMemberService } from '../../services/CPMember.service';
import { SelfMember } from '../../models/self-member.model';
import { Policy } from '../../models/policy.model';
import { Router } from '@angular/router';
import { CPPolicyService } from 'src/app/corporate-portal/services/cp-policy.service';
import { TrackingService } from 'src/app/Tracking.service';

@Component({
  selector: 'app-cp-member-enrollment',
  templateUrl: './cp-member-enrollment.component.html',
  styleUrls: ['./cp-member-enrollment.component.scss'],
})
export class CpMemberEnrollmentComponent implements OnInit {
  currentPolicy: Policy;
  policies = [];
  isHr: boolean;
  isMember: boolean;
  isHrView: boolean;
  memberSelf: SelfMember;
  isMemberSelfLoaded = false;
  family;
  isEmployeeBelongsToPolicy = false;
  isLoading = true;
  constructor(
    private readonly router: Router,
    private policyService: CPPolicyService,
    private cpMemberService: CPMemberService,
    private tracking : TrackingService
  ) {}

  ngOnInit() {
    this.memberSelf = new SelfMember();
    this.policyService.policies.subscribe(policies => {
      this.policies = policies;
    });

    this.cpMemberService.isHrView.subscribe(x => {
      this.isHrView = x;
      if (this.isHrView) {
        this.router.navigate(['/cp-member/profile']);
      }
    });
    this.isLoading = true;
    this.policyService.currentPolicy.subscribe(async (policy: any) => {
      this.currentPolicy = policy;
      this.isEmployeeBelongsToPolicy = this.currentPolicy.isMemberEnrolled;
      this.isHr = this.cpMemberService.isHr;
      this.isMember = this.cpMemberService.isMember;
      if (this.currentPolicy.policyNumber) {
        await this.cpMemberService
          .getMemberFamily(this.currentPolicy.policyNumber)
          .then(x => {
            // console.log(x);
            this.family = x;
            this.isLoading = false;
          })
          .catch(x => {
            // console.log('error');
            this.isLoading = false;
          });
      }

      if (policy.policyNumber !== undefined && this.isMember === true && this.currentPolicy.isMemberEnrolled) {
        this.cpMemberService.selfMemberDetails.subscribe(m => {
          this.memberSelf = m;
          this.isMemberSelfLoaded = true;
        });
      }
    });
  }

  onNamePolicyChanged(policy) {
    this.policyService.currentPolicy.next(policy);
  }

  redirectToAddMembers() {
    this.tracking.pushEvent("add_members", {});
    this.router.navigate(['/cp-member/add-family-member']);
  }
}
